import { call, query } from "./calls";

export const Event = {
    list: () => query("SELECT * FROM Event"),
    getSelectOptions: () => query("SELECT name as label, artifactName as value, description FROM Event"),
    create: (event) => call("/Event", "POST", event),
    delete: (eventId) => call(`/Event/${eventId}`, "DELETE"),
    update: (id, event) => call(`/Event/${id}`, "PUT", event),
    search: (q) => query(`select * from Event where isNotNull(name) and name != '' and name like '${q}' order by name`),
};